import React from "react";
import { Navigate } from "react-router-dom";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import { useU2000AuthContext } from "../u2000Core/context/auth/U2000UseAuthContext";
import U3125, { U3125ROLES } from "./U3125";
import U3125FactureList from "./components/U3125FactureList";
import U3125FactureForm from "./components/U3125FactureForm";
import U3125ForfaitWizardPage from "./components/wizard/U3125ForfaitWizardPage";
import U3125ArAgingReportPage from "./components/report/U3125ArAgingReportPage";

/** Garde ADD pour la page wizard (U2000RequireRole ne rend que Outlet, pas d'enfants). */
const U3125ForfaitWizardRoute: React.FC = () => {
  const { hasRole } = useU2000AuthContext();
  if (!hasRole(U3125ROLES.ADD)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return <U3125ForfaitWizardPage />;
};

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  children?: RouteObject[];
}

const U3125Routes: RouteObject[] = [
  {
    path: "U3125",
    element: <U2000RequireRole allowedRoles={[U3125ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3125 />,
        children: [
          { index: true, element: <U3125FactureList /> },
          { path: "forfait-wizard", element: <U3125ForfaitWizardRoute /> },
          { path: "ar-aging-report", element: <U3125ArAgingReportPage /> },
          { path: ":id", element: <U3125FactureForm /> },
        ],
      },
    ],
  },
];

export default U3125Routes;
